import { Button, Modal } from "antd"
import "./style.scss"

export default function ModalLogout({
  openLogout,
  setOpenLogout,
  handleLogout,
}) {
  return (
    <Modal
      className="modal-logout-style"
      title={<span>Xác nhận</span>}
      open={openLogout}
      onCancel={() => setOpenLogout(false)}
      footer={_ => (
        <div style={{ display: "flex", justifyContent: "center" }}>
          <div>
            <Button
              onClick={() => {
                handleLogout();
                setOpenLogout(false);
              }}
              type="primary"
            >
              Đồng ý
            </Button>

            <Button
              style={{ marginLeft: 10 }}
              onClick={() => setOpenLogout(false)}
              type="primary"
              danger
            >
              Bỏ qua
            </Button>
          </div>
        </div>
      )}
    >
      <p style={{ textAlign: "center" }}>Bạn có thực sự muốn thoát?</p>
    </Modal>
  )
}



















